/**
 * Config-driven registry of every simple "core setting" lookup resource —
 * mirrors the backend's 14 `AbstractLookupController<T>` subclasses. One
 * generic page (`LookupSettingsPage`) renders all of them; adding a new
 * lookup resource here is normally the only frontend change needed.
 */
const SETTINGS_RESOURCES = [
  { key: "academic-years", path: "academic-years", label: "Academic Years" },
  { key: "classes", path: "classes", label: "Classes", extraField: { name: "nameBangla", label: "Name (Bangla)", editable: true } },
  { key: "shifts", path: "shifts", label: "Shifts" },
  { key: "sections", path: "sections", label: "Sections" },
  { key: "groups", path: "groups", label: "Groups" },
  { key: "student-categories", path: "student-categories", label: "Student Categories" },
  { key: "subjects", path: "subjects", label: "Subjects", extraField: { name: "shortName", label: "Short Name", editable: true } },
  {
    key: "fee-heads",
    path: "fee-heads",
    label: "Fee Heads",
    extraField: { name: "defaultId", label: "Default ID", editable: true, type: "number", required: false },
  },
  { key: "fee-subheads", path: "fee-subheads", label: "Fee Sub Heads" },
  { key: "fee-waivers", path: "fee-waivers", label: "Fee Waivers" },
  { key: "sessions", path: "sessions", label: "Sessions" },
  {
    key: "periods",
    path: "periods",
    label: "Periods",
    extraField: { name: "defaultId", label: "Period Number", editable: true, type: "number", required: true },
  },
  {
    key: "exams",
    path: "exams",
    label: "Exams",
    extraField: { name: "defaultId", label: "Default ID (auto: 99 = Grand Final)", editable: false },
  },
  { key: "designations", path: "designations", label: "Designations" },
];

export default SETTINGS_RESOURCES;

export function findSettingsResource(key) {
  return SETTINGS_RESOURCES.find((r) => r.key === key);
}

/**
 * resourceKey -> the real digicampusbd per-institute menu url that reaches
 * it (see pageRegistry.js). "sessions" has no real menu url of its own (not
 * a real child_nav_item row — confirmed via a live query), so it's reachable
 * only through the super-admin-fixed /admin/settings/sessions route.
 */
export const RESOURCE_KEY_TO_MENU_URL = {
  "academic-years": "initial-setup-academic-year",
  classes: "initial-setup-class",
  shifts: "initial-setup-shift",
  sections: "initial-setup-section",
  groups: "initial-setup-group",
  "student-categories": "initial-setup-student-category",
  subjects: "initial-setup-subject",
  "fee-heads": "initial-setup-fee-head",
  "fee-subheads": "initial-setup-fee-sub-head",
  "fee-waivers": "initial-setup-fee-waiver",
  periods: "initial-setup-period",
  exams: "initial-setup-exam",
  designations: "initial-setup-designation",
};
